
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tournaments/[brackets]",
      function () {
        return require("private-next-pages/tournaments/[brackets].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tournaments/[brackets]"])
      });
    }
  